module.exports = __webpack_public_path__ + "static/media/archero2_page_area01_img_cn@2x.19bf112b.jpg";